module.exports = {
	home: {
		bindAccountTitle: '綁定FUNDOLL帳號',
		getNameTitle: '設置帳號名稱',
		linkAccountTitle: '關聯帳號',
		yinjicode: '引繼碼',
		changePsw: '設置/修改密碼',
		cancelAccountTitle: '刪除遊客帳號',
		// loginDeviceTitle: '登入裝置管理',
		bindAccountBtn: '绑定FUNDOLL账号',
		accountTitle: '帳號',
		checkAccountBtn: '切換帳號',
		changePswTitle: '修改密碼',
		clickPswTitle: '點擊修改',
		binded: '已綁定',
		goChangeBind: '前往換綁',
		goBind: '前往綁定',
		emailBindTitle: '綁定電子郵件',
		privacyTitls: '隱私政策',
		FAQTitle: '常見問題',
		kefu: '客服',
		query: '自助査詢中心',
		logOffTitle: '刪除帳號',
		accountTitle1: '帳號名稱',
		accountIdTitle: '帳號ID',
		changeEmailBtn: '換綁電子郵件',
		touristName: '遊客用戶',
		touristTitle: '已認證',
		logOut: '登出',
		setNameTitle: '請輸入您想設置的帳號名稱',
		bindAccountsTips: '註: 綁定的帳號下不能存在其他遊戲角色。',
		gotoBindBtn: '前往綁定',
		binded: '已綁定',
	},
	toast: {
		verifycodeBtn: '獲取',
		verifycodeBtn2: '重新獲取',
		comfirmBtn1: '確定',
		comfirmBtn2: '取消',
		emailPlaceholder: '請輸入電子郵件',
		setNamePlaceholder: '請輸入帳號名稱',
		setNameTitls: '由7-16位字母、數字組成，必須存在一位字母',
		verifyTitle: '請輸入驗證碼',
		pswTitle1: '請輸入新密碼',
		pswTitle2: '請再次確認輸入新密碼',
		comfirmPswTips: '兩次輸入的密碼需要相同',
		verifypswTips: '密碼長度為6-18位非中文/空格字符',
		newverifypswTips: '請輸入密碼',
		verifyemailTips: '格式錯誤，無法識別，請重新輸入',
		noEmail: '請輸入要綁定的電子郵件',
		longTime: '停留頁面時間太長，請重新驗證',
		noInfo: '暫未收集到信息',
		binded: '您的帳號已被綁定。如有疑問請聯繫客服查詢',
		banCancelAccount: '不能解綁當前授權登入的{name}帳號',
		noEmail1: '請輸入電子郵件',
		logout1: '裝置登出操作成功',
	},
	logoff: {
		logoffTipsText1:
			'1.在您提交帳號刪除申請次日起的15天內，我們將處理您的刪除申請。若您在15天屆滿前重新登入該遊戲帳號，則刪除申請將被自動撤銷。',
		logoffTipsText2: '2.帳號刪除成功後，您將永久無法使用該遊戲帳號。',
		logoffTipsText3:
			'3.如果您有任何疑問，請在工作時間（週一到週日10:00-19:00）聯繫客服諮詢。',
		logoffTipsBtn: '確認刪除',
		text1: '為了保障您的帳號安全',
		text2: '您的帳號刪除申請提交成功!',
		text11: '您的帳號刪除成功!',
		text3: `您已於{time}成功提交帳號刪除申請，現您的帳號處於刪除流程中。 `,
		text4: `您的帳號將於{time}刪除。在此之前，若您登入該通行證帳號，您的刪除流程將自動撤銷。`,
		text5: '提示',
		text9: '區服',
		text7: '角色',
		text8: '等級',
		text10: '請仔細閱讀刪除須知',
		text6: '確認刪除後，您的遊客帳號將被重置為全新帳號，當前的遊戲記錄將無法找回。請謹慎操作。',
		tourText2: '遊戲',
		tourText3: '遊戲角色',
		tourText4: '遊戲UID',
		tourText5: '遊戲等級',
		logoffScuessTips: '您已申請刪除帳號，登入狀態失效。',
		agreementTips: '我已详细阅读并同意{name}',
		buttonText: '閱讀刪除協議',
		buttonText1: '前往刪除',
	},
	title: {
		title: '個人中心',
		title1: '隱私政策',
		title2: '常見問題',
		title3: '客服',
		title4: '安全驗證',
		title5: '綁定FUNDOLL帳號',
		title6: '綁定郵箱',
		title7: '修改密碼',
		title8: '刪除須知',
		title9: '帳號刪除提醒',
		title10: '設置帳號名',
		title11: '解綁帳號',
		title12: '關聯帳號',
		title13: '刪除須知',
		title14: '刪除確認',
		title15: '帳號刪除提醒',
		title16: '登入設備管理',
		title18: '換綁郵箱',
		title19: '帳號名設置',
		netError: '網路出錯無法進行操作,請檢查網路連線',
		title20: '刪除協議',
		title21: '隱私權政策',
		title22: '使用者協議',

		title23: '引继码',
		title24: '绑定引继码',
		title25: '查看引继码',
	},
	verifyText: {
		titleTxt1:
			'為了保護您的帳號安全，設定新的帳號名稱之前，請先驗證帳號綁定的電子郵件信箱',
		titleTxt2:
			'為了保護您的帳號安全，關聯新帳號之前，請先驗證帳號綁定的電子郵件信箱',
		titleTxt3:
			'為了保護您的帳號安全，修改密碼之前，請先驗證帳號綁定的電子郵件信箱',
		titleTxt4:
			'為了保護您的帳號安全，進行設備管理之前，請先驗證帳號綁定的電子郵件信箱',
		titleTxt5:
			'為了保護您的帳號安全，換綁電子郵件信箱之前，請先驗證目前綁定的電子郵件信箱',
		titleTxt6:
			'為了保護您的帳號安全，解除綁定之前，請先驗證帳號綁定的電子郵件信箱',
		title1: '電子郵件信箱',
	},
	successText: {
		goBack: '返回',
		successTitle1: '綁定成功',
		successTitle2: '解除綁定成功',
		successTitle3: '更換郵箱成功',
		successTitle4: '設置成功',
	},
	bindAccountText: {
		text1: '解綁',
		text2: '綁定',
		text3: '已有帳號',
		text4: '註冊並綁定',
		text5: '為了保護您的帳號安全，請先驗證帳號綁定的電子信箱',
		text6: '绑定FUNDOLL账号',
		text7: '請輸入通行證帳號/電子信箱號碼/帳號名稱',
		text8: '您的帳號已被綁定。如有疑問請聯繫客服查詢',
	},
	preamble: {
		tx1: '在本台裝置上使用引繼碼後，該裝置登入的遊戲記錄將會被清除，並取代為該引繼碼的遊戲記錄，之前裝置將無法使用該引繼碼的遊戲記錄。',
		tx2: '綁定引繼碼',
		tx3: '在其他裝置上綁定引繼碼後，您將能在其他裝置上使用該帳號的遊戲記錄，同時本台裝置的遊戲記錄將會被清除。',
		tx4: '查看引繼碼',
		tx5: '請輸入您想要綁定帳號的引繼碼',
		tx6: '引繼碼密碼',
		tx7: '(如未設置過引繼碼密碼可不填寫該項內容)',
		tx8: '請輸入該引繼碼的密碼',
		tx9: '與目前裝置的引繼碼相同，不可使用',
		tx10: '暫無遊戲角色',
		tx11: '點選「確定使用」後，先前的裝置將無法登入該遊戲角色。',
		tx12: '確定綁定',
		tx13: '綁定成功！',
		tx14: '(一旦設置引繼碼密碼便不能更改)',
		tx15: '複製',
		tx16: '密碼設置成功！',
		tx17: '複製成功！',
		tx18: '複製失敗，請手動選擇複製！',
	},
};
